export default function(data = {}) {
    this.name = data.name;
    this.active = data.active;
    this.sort = data.sort;
}
